module.exports = __webpack_public_path__ + "static/media/favicon.68cbe1e8.ico";